(function () {
  var HEADER_OFFSET = 80;

  function getHeaderOffset() {
    var header = document.querySelector(".section-header") || document.querySelector("[data-header-section]");
    if (!header) return HEADER_OFFSET;
    return Math.ceil(header.getBoundingClientRect().height) || HEADER_OFFSET;
  }

  function closeOffcanvasMenu() {
    var offcanvasEl = document.getElementById("offcanvasMenu");
    if (!offcanvasEl || !window.bootstrap || !bootstrap.Offcanvas) return;
    var instance = bootstrap.Offcanvas.getInstance(offcanvasEl);
    if (instance) instance.hide();
  }

  function scrollToHash(hash, updateHistory) {
    if (!hash || hash === "#") return false;
    var id = decodeURIComponent(hash.replace(/^#/, ""));
    var target = document.getElementById(id);
    if (!target) return false;

    var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var top = target.getBoundingClientRect().top + window.pageYOffset - getHeaderOffset();

    window.scrollTo({
      top: Math.max(0, top),
      behavior: reduceMotion ? "auto" : "smooth",
    });

    if (updateHistory && history.pushState) {
      history.pushState(null, "", "#" + id);
    }

    return true;
  }

  document.addEventListener("click", function (event) {
    var link = event.target.closest("a[data-anchor-link], a[href^='#'], a[href*='/#']");
    if (!link) return;

    var href = link.getAttribute("href");
    if (!href) return;

    var hashIndex = href.indexOf("#");
    if (hashIndex === -1) return;

    var hash = href.slice(hashIndex);
    if (hash.length < 2) return;

    // Same-page hash only (/, /en, current path, or bare #id)
    var pathPart = href.slice(0, hashIndex);
    var isSamePage =
      pathPart === "" ||
      pathPart === "/" ||
      pathPart === window.location.pathname ||
      href.indexOf(window.location.origin + window.location.pathname) === 0 ||
      (pathPart.charAt(0) === "/" && pathPart.replace(/\/$/, "") === window.location.pathname.replace(/\/$/, ""));

    if (!isSamePage && pathPart !== "" && pathPart !== "/") {
      // Going to homepage with hash from another page — let browser navigate
      closeOffcanvasMenu();
      return;
    }

    if (!document.getElementById(hash.slice(1))) return;

    event.preventDefault();
    closeOffcanvasMenu();
    scrollToHash(hash, true);
  });

  window.addEventListener("load", function () {
    if (window.location.hash) {
      setTimeout(function () {
        scrollToHash(window.location.hash, false);
      }, 50);
    }
  });
})();
